//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './DataBlockDictionaryClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';


export type GetDependantDictionariesDataBlockDictionaryQueryParameters = {
  dictionaryId?: number | undefined ;
}

export type PatchDataBlockDictionaryQueryParameters = {
  id: number ;
}

export type RemoveDataBlockDictionaryQueryParameters = {
  id: number ;
}

export function getUrl(): string {
  let url_ = getBaseUrl() + "/api/data-blocks/dictionaries";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.DataBlockDictionaryDto[], unknown, Types.DataBlockDictionaryDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.DataBlockDictionaryDto[], unknown, Types.DataBlockDictionaryDto[]>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'DataBlockDictionaryClient',
      'get',
    ]);
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
axiosConfig    );
}

export function useGetQuery<TSelectData = Types.DataBlockDictionaryDto[], TError = unknown>(options?: Omit<UseQueryOptions<Types.DataBlockDictionaryDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.DataBlockDictionaryDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.DataBlockDictionaryDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.DataBlockDictionaryDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.DataBlockDictionaryDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetData(queryClient: QueryClient, updater: (data: Types.DataBlockDictionaryDto[] | undefined) => Types.DataBlockDictionaryDto[], ) {
  queryClient.setQueryData(getQueryKey(),
    updater
  );
}

export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.DataBlockDictionaryDto[] | undefined) => Types.DataBlockDictionaryDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function createUrl(): string {
  let url_ = getBaseUrl() + "/api/data-blocks/dictionaries";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createMutationKey(): MutationKey {
  return trimArrayEnd([
      'DataBlockDictionaryClient',
      'create',
    ]);
}

export function useCreateMutation<TContext>(options?: Omit<UseMutationOptions<Types.DataBlockDictionaryDto, unknown, Types.CreateDataBlockDictionaryDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.DataBlockDictionaryDto, unknown, Types.CreateDataBlockDictionaryDto, TContext> {
  const key = createMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreateDataBlockDictionaryDto) => Client.create(dto),
    mutationKey: key,
  });
}
  
export function getDependantDictionariesUrl(dictionaryId?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/data-blocks/dictionaries/dependants?";
if (dictionaryId === null)
    throw new Error("The parameter 'dictionaryId' cannot be null.");
else if (dictionaryId !== undefined)
    url_ += "dictionaryId=" + encodeURIComponent("" + dictionaryId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDependantDictionariesDefaultOptions: Omit<UseQueryOptions<number[], unknown, number[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<number[], unknown, number[]>, 'queryFn'>> = {
};
export function getGetDependantDictionariesDefaultOptions() {
  return getDependantDictionariesDefaultOptions;
};
export function setGetDependantDictionariesDefaultOptions(options: typeof getDependantDictionariesDefaultOptions) {
  getDependantDictionariesDefaultOptions = options;
}

export function getDependantDictionariesQueryKey(dictionaryId?: number | undefined): QueryKey;
export function getDependantDictionariesQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { dictionaryId,  } = params[0] as GetDependantDictionariesDataBlockDictionaryQueryParameters;

    return trimArrayEnd([
        'DataBlockDictionaryClient',
        'getDependantDictionaries',
        dictionaryId as any,
      ]);
  } else {
    return trimArrayEnd([
        'DataBlockDictionaryClient',
        'getDependantDictionaries',
        ...params
      ]);
  }
}
export function __getDependantDictionaries(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getDependantDictionaries(
      context.queryKey[2] as number | undefined,axiosConfig    );
}

export function useGetDependantDictionariesQuery<TSelectData = number[], TError = unknown>(dto: GetDependantDictionariesDataBlockDictionaryQueryParameters, options?: Omit<UseQueryOptions<number[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetDependantDictionariesQuery<TSelectData = number[], TError = unknown>(dictionaryId?: number | undefined, options?: Omit<UseQueryOptions<number[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetDependantDictionariesQuery<TSelectData = number[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<number[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let dictionaryId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ dictionaryId,  } = params[0] as GetDependantDictionariesDataBlockDictionaryQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [dictionaryId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<number[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getDependantDictionaries(context, axiosConfig) : __getDependantDictionaries,
    queryKey: getDependantDictionariesQueryKey(dictionaryId),
    ...getDependantDictionariesDefaultOptions as unknown as Omit<UseQueryOptions<number[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetDependantDictionariesData(queryClient: QueryClient, updater: (data: number[] | undefined) => number[], dictionaryId?: number | undefined) {
  queryClient.setQueryData(getDependantDictionariesQueryKey(dictionaryId),
    updater
  );
}

export function setGetDependantDictionariesDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: number[] | undefined) => number[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function patchUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/data-blocks/dictionaries/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'DataBlockDictionaryClient',
      'patch',
      id as any,
    ]);
}

export function usePatchMutation<TContext>(id: number, options?: Omit<UseMutationOptions<Types.DataBlockDictionaryDto, unknown, Types.DataBlockDictionaryPatchDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.DataBlockDictionaryDto, unknown, Types.DataBlockDictionaryPatchDto, TContext> {
  const key = patchMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.DataBlockDictionaryPatchDto) => Client.patch(id, dto),
    mutationKey: key,
  });
}
  
type Patch__MutationParameters = PatchDataBlockDictionaryQueryParameters & {
  dto: Types.DataBlockDictionaryPatchDto;
}

export function usePatchMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.DataBlockDictionaryDto, unknown, Patch__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PatchDataBlockDictionaryQueryParameters}): UseMutationResult<Types.DataBlockDictionaryDto, unknown, Patch__MutationParameters, TContext> {
  const key = patchMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Patch__MutationParameters) => Client.patch(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}
  
export function removeUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/data-blocks/dictionaries/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'DataBlockDictionaryClient',
      'remove',
      id as any,
    ]);
}

export function useRemoveMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.remove(id),
    mutationKey: key,
  });
}
  
type Remove__MutationParameters = RemoveDataBlockDictionaryQueryParameters

export function useRemoveMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Remove__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RemoveDataBlockDictionaryQueryParameters}): UseMutationResult<void, unknown, Remove__MutationParameters, TContext> {
  const key = removeMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Remove__MutationParameters) => Client.remove(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}